<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><a class="a_disabled">协会工作部</a></li> -->
                <li><router-link :to="titleLink">{{ title }}</router-link></li>
                <li class="currentNode"><a>联系方式</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>{{ title }}</a></li>
                    <li><router-link :to="`/layout/info-branch-introduction?id=${id}`">工作部简介</router-link></li>
                    <li><router-link :to="`/layout/info-branch-responsibilities?id=${id}`">主要职责</router-link></li>

                </ul>
                <div class="page-content">
                    <h3>联系方式</h3>
                    <p><strong>地址：</strong>{{ address }}</p>
                    <p><strong>邮箱：</strong>{{ webSite }}</p>
                    <p><strong>电话：</strong>{{ tel }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name:'',
    data() {
        return {
            id: '', // 信息工作部1，双招双引工作部2，医疗卫生工作部3，企业工作部4
            title: '',
            tel: '',   
            address: '',
            webSite: '', 
            titleLink: '',
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getXiehuiModel();
        this.traverseTitle();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        traverseTitle() {
            if (this.id === '1'){
                this.title = "信息工作部";
                this.titleLink = '/layout/info-branch-introduction?id=1';
            } else if (this.id === '2'){
                this.title = "双招双引工作部";
                this.titleLink = '/layout/info-branch-introduction?id=2';
            } else if (this.id === '3') {
                this.title = "医药卫生工作部";
                this.titleLink = '/layout/info-branch-introduction?id=3';
            } else {
                this.title = "企业工作部";
                this.titleLink = '/layout/info-branch-introduction?id=4';
            }
        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tel = res.Data.Tel;
                    this.address = res.Data.Address;
                    this.webSite = res.Data.EstablishedTime;
                } else {
                    this.$message.error("协会党建请求失败");
                }
            })
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.getXiehuiModel();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
        '$route.query.id': {
            handler: function(toId, fromId){
                this.id = toId;
                this.getXiehuiModel();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    height: 300px;
    box-sizing: border-box;
}
.page-content h3{
    text-align:center;
    margin-bottom: 50px;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width:450px;
    margin:0 auto;
}
.page-content p strong {
    color: #1D2129;
}
.a_disabled {
    cursor: not-allowed;
}
</style>